import React, { useState } from 'react';
import { Button, Select, Space, Typography, Card } from 'antd';
import { useTranslation } from 'react-i18next';
import { changeLanguage, getSupportedLanguages, getCurrentLanguage } from '../i18n';
import LanguageSelector from './LanguageSelector';

const { Title, Text } = Typography;
const { Option } = Select;

const InternationalizationTest = () => {
  const { t, i18n } = useTranslation();
  const [selectedModel, setSelectedModel] = useState('auto');
  
  const supportedLanguages = getSupportedLanguages();
  const currentLanguage = getCurrentLanguage();
  
  // 模拟模型选项
  const modelOptions = [
    { value: 'auto', label: t('common.autoSelect') },
    { value: 'gpt-4', label: 'GPT-4' },
    { value: 'gpt-3.5', label: 'GPT-3.5' },
    { value: 'claude', label: 'Claude' }
  ];

  const handleLanguageChange = async (languageCode) => {
    await changeLanguage(languageCode);
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <Title level={2}>🌐 国际化测试</Title>
      
      <Card title="语言切换" style={{ marginBottom: '20px' }}>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div>
            <Text strong>当前语言：</Text>
            <Text>{currentLanguage.flag} {currentLanguage.nativeName} ({i18n.language})</Text>
          </div>
          
          <div>
            <Text strong>语言选择器：</Text>
            <LanguageSelector type="dropdown" />
          </div>
          
          <div>
            <Text strong>快速切换：</Text>
            <Space>
              {Object.entries(supportedLanguages).map(([code, info]) => (
                <Button
                  key={code}
                  type={i18n.language === code ? 'primary' : 'default'}
                  onClick={() => handleLanguageChange(code)}
                  icon={<span>{info.flag}</span>}
                >
                  {info.nativeName}
                </Button>
              ))}
            </Space>
          </div>
        </Space>
      </Card>

      <Card title="模型选择测试" style={{ marginBottom: '20px' }}>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div>
            <Text strong>下拉框测试：</Text>
            <Select
              value={selectedModel}
              onChange={setSelectedModel}
              style={{ width: 200, marginLeft: 10 }}
              placeholder={t('common.selectModel')}
            >
              {modelOptions.map(option => (
                <Option key={option.value} value={option.value}>
                  {option.label}
                </Option>
              ))}
            </Select>
          </div>
          
          <div>
            <Text strong>当前选择：</Text>
            <Text code>{selectedModel}</Text>
          </div>
          
          <div>
            <Text strong>国际化文本测试：</Text>
            <ul>
              <li><Text>自动选择: {t('common.autoSelect')}</Text></li>
              <li><Text>选择模型: {t('common.selectModel')}</Text></li>
              <li><Text>加载中: {t('common.loading')}</Text></li>
              <li><Text>错误: {t('common.error')}</Text></li>
            </ul>
          </div>
        </Space>
      </Card>

      <Card title="调试信息">
        <Space direction="vertical" size="small">
          <div>
            <Text strong>i18n.language:</Text> <Text code>{i18n.language}</Text>
          </div>
          <div>
            <Text strong>i18n.resolvedLanguage:</Text> <Text code>{i18n.resolvedLanguage}</Text>
          </div>
          <div>
            <Text strong>localStorage i18nextLng:</Text> <Text code>{localStorage.getItem('i18nextLng')}</Text>
          </div>
          <div>
            <Text strong>navigator.language:</Text> <Text code>{navigator.language}</Text>
          </div>
        </Space>
      </Card>
    </div>
  );
};

export default InternationalizationTest;
